import Action from './action';
import { equar } from '../../../utils/common';

const initialState = {
    historicalContactPerson: [],
    errorTexts: []
};

export default (state = initialState, action: {type: string, playload: string | number | string[]}) => {
    switch (action.type) {
        case Action.UPDATE_HISTORICAL_CONTACT_PERSON: {
            return {
                ...state,
                historicalContactPerson: action.playload
            }
        }
        case Action.UPDATE_HISTORICAL_CONTACT_PERSON_ERROR_TEXT: {
            try {
                const newErrors = (action.playload as string[] || []).filter(Boolean);
                const curErrors = state.errorTexts.filter(Boolean);
                if (!equar(newErrors, curErrors) && newErrors.length >= curErrors.length) {
                    (window as any).mailStats.show('historical_contact_person_error', { errorText: action.playload })
                }
            } catch(e) {}
            return {
                ...state,
                errorTexts: action.playload
            }
        }
        case Action.UPDATE_HISTORICAL_CONTACT_PERSON_ERROR_TEXT_BY_INDEX: {
            state.errorTexts.splice(action.playload as number, 1)
            return {
                ...state,
                errorTexts: [...state.errorTexts]
            }
        }
        default: return state;
    }
}
